/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import axios, { LOGIN } from '../../utils/api';
import { useSession, signIn } from 'next-auth/react';
import { useRouter } from 'next/router';
import messageBanner from './messageBanner';
import { useDispatch, useSelector } from 'react-redux';
import { setUserId, setUserInfo } from '@redux/auth/authSlice';

export default function GoogleLoginButton({ wasSuccess, loadingData }) {
  const { data: session, status } = useSession();
  const router = useRouter();

  const userinfo = useSelector((state) => state.auth.userInfo);

  const dispatch = useDispatch();

  useEffect(() => {
    if (session && session?.user?.email && !localStorage.getItem('userid')) {
      const loginOrCreate = async () => {
        loadingData(true);

        const userObj = {
          firstName: session?.user?.name?.split(' ')[0],
          lastName: session?.user?.name?.split(' ')[1],
          email: session?.user?.email,
          googleToken: session?.accessToken ?? '',
          googleRefreshToken: session?.refreshToken ?? '',
          avatar: {
            secure_url: session?.user?.image ?? '',
            public_id: '',
          },
          banner: {
            secure_url: '',
            public_id: '',
          },
        };
        const data = await axios.post(LOGIN, userObj);
        // 409 means this is an existing user -- take home
        if (data.data.statusCode === 409) {
          loadingData(false);
          if (data.data.user.handle) {
            localStorage.setItem('userid', data.data.user._id);
            dispatch(setUserId(data.data.user._id));
            dispatch(setUserInfo(data.data.user));
            localStorage.setItem('handle', data.data.user?.handle);
            localStorage.setItem('first', 'one');
            router.push('/');
          } else {
            localStorage.setItem('userid', data.data.user._id);
            dispatch(setUserId(data.data.user._id));
            dispatch(setUserInfo(data.data.user));
            if (!data?.data?.user?.handle) {
              wasSuccess(true);
            }
          }
        } else {
          // new user -- need to create handle
          loadingData(false);
          console.log('data', data?.data);
          localStorage.setItem('userid', data.data._id);
          dispatch(setUserId(data.data._id));
          dispatch(setUserInfo(data.data));
          messageBanner({
            message: `Welcome to Karent, ${session?.user?.name?.split(' ')[0]}`,
            status: 'success',
          });
          wasSuccess(true);
        }
      };
      if (!userinfo?._id) {
        loginOrCreate();
      }
      loadingData(true);
      // wasSuccess(true);
    } else {
      console.log('');
    }
  }, [session]);

  return (
    <button
      onClick={() => signIn('google')}
      className="flex items-center gap-4 rounded-3xl bg-white px-6 py-2 text-black"
    >
      {status === 'authenticated' ? 'Ready' : 'Continue with google'}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="#f40101"
        className="h-6 w-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
        />
      </svg>
    </button>
  );
}

// proptypes
GoogleLoginButton.propTypes = {
  renderChildren: PropTypes.func.isRequired,
  showMessage: PropTypes.func.isRequired,
  wasSuccess: PropTypes.func.isRequired,
  loadingData: PropTypes.func.isRequired,
};
